import {useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom"
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from './Loader'

//components

const Settings = () => {
    const {user} = useAuthContext()
    const navigate = useNavigate()

    useEffect(() => {  //code that runs after render //useEffects are side effects that happens when something renders/something changes
        if (!user) {
            navigate('/login')
            return
        }
    }, [user, navigate])  //with an empty array it only fires once when the component renders, things like [count] re-runs each time count state changes

    if (!user) {
        return <Loader />
    }

    return (
        <div className="settings">
            <h3>Settings</h3>
            <Link to="/request-password-reset">
                <span className="reset-password-btn">Reset Password</span>
            </Link>
        </div>
    )
}

export default Settings